export default {
  listTaskColumns(data) {
    return this.http('DataInterface', 'get', 'v1/banniu/list-task-column', data);
  },
  createBanniuTask(data) {
    return this.http('DataInterface', 'post', 'v1/banniu/create-task', data);
  }
};
